var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RouteHandler from "../App/RouteHandler";
import qs from 'qs';
import { Icon } from "../UI";
import { Translate } from "../I18N";
import { withRouter } from "../componentWrappers";

import auth from "../Auth";

class ResetPasswordComponent extends RouteHandler {
  constructor(props, context) {
    super(props, context);
    this.state = { error: false, password: '', repeatPassword: '' };
    this.submit = this.submit.bind(this);
    this.passwordChange = this.passwordChange.bind(this);
    this.repeatPasswordChange = this.repeatPasswordChange.bind(this);
  }

  passwordChange(e) {
    this.setState({ password: e.target.value });
    this.setState({ passwordError: false });
  }

  repeatPasswordChange(e) {
    this.setState({ repeatPassword: e.target.value });
    this.setState({ passwordError: false });
  }

  submit(e) {
    e.preventDefault();
    const passwordsDontMatch = this.state.password !== this.state.repeatPassword;
    const emptyPassword = this.state.password.trim() === '';
    if (emptyPassword || passwordsDontMatch) {
      this.setState({ error: true });
      return;
    }

    this.props.resetPassword(this.state.password, this.props.params.key).then(() => {
      this.props.navigate('/login');
    });

    this.setState({ password: '', repeatPassword: '' });
  }

  render() {
    return (/*#__PURE__*/
      _jsx("div", { className: "content login-content" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "col-xs-12 col-sm-4 col-sm-offset-4" }, void 0,
      qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).createAccount ===
      'true' && /*#__PURE__*/
      _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle" }), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "To complete the account creation process, please create a password for your account"


      )
      )
      ), /*#__PURE__*/

      _jsx("form", { onSubmit: this.submit }, void 0, /*#__PURE__*/
      _jsx("div", { className: `form-group login-email ${this.state.error ? 'has-error' : ''}` }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "password" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Password")
      ), /*#__PURE__*/
      _jsx("input", {
        onChange: this.passwordChange,
        value: this.state.password,
        type: "password",
        name: "password",
        id: "password",
        className: "form-control" }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: `form-group login-password ${this.state.error ? 'has-error' : ''}` }, void 0, /*#__PURE__*/
      _jsx("label", { className: "form-group-label", htmlFor: "repeat-password" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Repeat Password")
      ), /*#__PURE__*/
      _jsx("input", {
        value: this.state.repeatPassword,
        onChange: this.repeatPasswordChange,
        type: "password",
        name: "repeat-password",
        id: "repeat-password",
        className: "form-control" }
      ),
      this.state.error && /*#__PURE__*/
      _jsx("div", { className: "required" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "mismatched passwords" }, void 0, "Passwords don\u2019t match"

      )
      )

      ), /*#__PURE__*/
      _jsx("button", { type: "submit", className: "btn btn-block btn-lg btn-primary" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save password")
      )
      )
      )
      )
      ));

  }
}

ResetPasswordComponent.propTypes = {
  resetPassword: PropTypes.func,
  params: PropTypes.shape({
    key: PropTypes.string
  })
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ resetPassword: auth.actions.resetPassword }, dispatch);
}

export { ResetPasswordComponent };
export default connect(null, mapDispatchToProps)(withRouter(ResetPasswordComponent));